import * as z from "zod/v4";

const ProfilePaginationSchema_ = z.object({
  pageSize: z.number().int(),
  nextPageToken: z.number().int(),
});
export const ProfilePaginationSchema: z.ZodType<ProfilePagination> =
  ProfilePaginationSchema_;
export interface ProfilePagination
  extends z.infer<typeof ProfilePaginationSchema_> {}
